// extracted by css-extract-rspack-plugin
export default {"desktopInstructionsText":"BranchNextStepDesktop-module__desktopInstructionsText__JSjNO"};